import { useParams } from 'react-router-dom';
import { useLocalization } from '@/context/useLocalization';

/**
 * Hook to get localized paths with language prefix
 * @param path - The path without language prefix (e.g., '/about', '/projects')
 * @returns The path with current language prefix (e.g., '/en/about', '/ar/projects')
 */
export const useLocalizedPath = () => {
    const { language } = useLocalization();
    const params = useParams<{ lang?: string }>();
    
    // Get the current language from URL params or fallback to context language
    const currentLang = params.lang || language;

    const getLocalizedPath = (path: string): string => {
        // Remove leading slash if present
        const cleanPath = path.startsWith('/') ? path.slice(1) : path;
        
        // If path is empty or just '/', return language root
        if (!cleanPath || cleanPath === '/') {
            return `/${currentLang}`;
        }
        
        // Return path with language prefix
        return `/${currentLang}/${cleanPath}`;
    };

    return { getLocalizedPath, currentLang };
};

